import { GelTheme } from 'components/GelTheme';
import { Sizing, Sizing2, SizingAny } from 'components/Layout/types';

export const toUnit = (value?: Sizing): string | undefined => {
  if (value == null) return undefined;
  if (typeof value === 'number') return GelTheme.spacing(value);
  return value as string;
};

export const resolveSizing = (value?: SizingAny | Sizing2 | Sizing, ...indexes: number[]): string | undefined => {
  if (value == null) return undefined;

  // One value e.g. 'margin: 2';
  if (!Array.isArray(value)) return toUnit(value);

  // Cater for measures being specified in multiple ways, e.g. margin could be -
  //
  //    margin: 2 4;      // y, x
  //    margin: 2 4 6;    // t, x, b
  //    margin: 2 4 6 8;  // t, r, b, l
  //
  // If no indexes are specified then just return the whole array as a string
  if (!indexes?.length) {
    return value.map(toUnit).join(' ');
  }

  // Otherwise just return the value at the first specified index. This caters for something like a bottom margin
  // which either uses the specified value (at index 2) or falls back to the top margin (at index 0).
  for (const index of indexes) {
    if (index < value.length) return toUnit(value[index]);
  }

  return undefined;
};
